import { ITradeSettingsStore } from "@/store/tradeSettingsStore";
import { setNumericSetting } from "@/store/tradeSettingsStoreACTIONS";
import { NotationToDecimalValueType } from "@/lib/interfaces and Enums/TYPENotations";
import {
  ICPSettingsOverride,
  IToggleButton,
} from "../../helper/tradeSettingsHelper/tradeSettingsInterfaces";
import { SettingDropdown } from "./SettingDropdown";
import { NumericSettingInput } from "./SelectPanelSettings";
import { syncPriceToLeg } from "./CPSettingsGrid";

interface IOrderSetLevelRowProps {
  esid: string;
  isStructure: boolean;
  orderSetLevel: IToggleButton[];
  orderSetLevelField: keyof ICPSettingsOverride & keyof ITradeSettingsStore;
  orderValueField: keyof ITradeSettingsStore;
  orderLevelDisabled: boolean;
  storeValue: number | string | undefined;
  notation: NotationToDecimalValueType | undefined;
  fontSizeClass: string;
  setLevelWidth: string;
  adviseCoverWidth: string;
  gap: string;
  dataStrategyType: string;
}

export function OrderSetLevelRow({
  esid,
  isStructure,
  orderSetLevel,
  orderSetLevelField,
  orderValueField,
  orderLevelDisabled,
  storeValue,
  notation,
  fontSizeClass,
  setLevelWidth,
  adviseCoverWidth,
  gap,
  dataStrategyType,
}: IOrderSetLevelRowProps) {
  return (
    <div className={`mt-2 flex items-center ${gap}`}>
      <div
        data-testid={
          isStructure ? "orderSetLevelStructure" : "orderSetLevelOutright"
        }
        id={isStructure ? "orderSetLevelStructure" : "orderSetLevelOutright"}
        className={setLevelWidth}
      >
        <div
          className={`mb-1 whitespace-nowrap uppercase tracking-wider text-gray-500 dark:text-gray-400 ${fontSizeClass}`}
        >
          Set Level
        </div>
        <SettingDropdown
          settingArray={orderSetLevel}
          esid={esid}
          settingField={orderSetLevelField}
          fontSizeClass={fontSizeClass}
        />
      </div>
      <div
        data-testid={isStructure ? "orderSpreadType" : "orderPriceType"}
        id={isStructure ? "orderSpreadType" : "orderPriceType"}
        className={adviseCoverWidth}
      >
        <div
          className={`mb-1 whitespace-nowrap uppercase tracking-wider text-gray-500 dark:text-gray-400 ${fontSizeClass}`}
        >
          {isStructure ? "Spread" : "Level"}
        </div>
        <NumericSettingInput
          id={isStructure ? "orderSpreadInput" : "orderLevelInput"}
          storeValue={storeValue}
          disabled={orderLevelDisabled}
          esid={esid}
          fieldName={orderValueField}
          notation={notation}
          fontSizeClass={fontSizeClass}
          onCommit={(value) => {
            setNumericSetting({
              esid,
              settingField: orderValueField,
              value: value,
            });
            if (orderValueField === "orderPriceValue") {
              syncPriceToLeg(esid, dataStrategyType, value);
            }
          }}
        />
      </div>
    </div>
  );
}

export default OrderSetLevelRow;
